import { ReactNode } from "react";
import Controls from "./Controls";
import { useTranslation } from "./Localization";
import Progress, { ProgressIcon } from "./Progress";
import RoomHeader from "./RoomHeader";
import { useTourMode } from "./TourMode";

type Props = { instruction?: string; taskKey?: string; step?: number; backTo: string; nextTo: string; showProgress?: boolean; progressIcon?: ProgressIcon; pageType?: "task" | "game"; children: ReactNode };

export default function LegacyActivityLayout({ instruction = "", taskKey, step = 0, backTo, nextTo, showProgress = true, progressIcon = "center", pageType = "task", children }: Props) {
  const { room } = useTranslation();
  const { interactive } = useTourMode();
  return <main className="screen activity legacy-activity">
    <RoomHeader roomId="legacy" />
    <p className="instruction">{(taskKey && room("legacy")?.tasks[taskKey]) || instruction}</p>
    <div className="legacy-task-content">{children}</div>
    {showProgress && <Progress step={step} total={4} icon={progressIcon} showDots={pageType === "game" || interactive} />}
    <Controls backTo={backTo} nextTo={nextTo} check={pageType === "game"} />
  </main>;
}
